import styled, { css } from "styled-components";

const ThumbMixin = css<{ $progressColor?: string, thumbSize?: number }>`
    height: ${({ thumbSize }) => thumbSize ? `${thumbSize}px` : "16px"};
    width: ${({ thumbSize }) => thumbSize ? `${thumbSize}px` : "16px"};
    border-radius: 50%;
    border: 0px solid white;
    background: ${({ theme, $progressColor }) => $progressColor ? $progressColor : theme.v3.colors.blue};
    cursor: pointer;
    outline: 15px solid transparent;

    &:focus {
        outline: none;
    }
`;

const TrackMixin = css<{ $barColor?: string }>`
    width: 100%;
    height: 4px;
    cursor: pointer;
    box-shadow: 0px 0px 0px #000000;
    background: ${({ theme, $barColor }) => $barColor ? $barColor : theme.v3.colors.grey96};
    border-radius: 2px;
    border: 0px solid #000000;
`;

export const V3RangeInpt = styled.input<{ $barColor?: string, $progressColor?: string, thumbSize?: number }>`
    width: 100%;
    height: 20px;
    -webkit-appearance: none;
    margin: 0;
    width: 100%;
    overflow: hidden;
    background: transparent;

    &:focus {
        outline: none;
    }
    &::-webkit-slider-runnable-track {
        ${TrackMixin}
    }
    &::-webkit-slider-thumb {
        ${ThumbMixin}
        -webkit-appearance: none;
        margin-top: ${({ thumbSize }) => {
        switch (thumbSize) {
            case 10:
                return "-3px";
            default:
                return "-6px";
        }
    }};
    }
    &:focus::-webkit-slider-runnable-track {
        background: ${({ theme, $barColor }) => $barColor ? $barColor : theme.v3.colors.grey96};
    }
    &::-moz-range-track {
        ${TrackMixin}
    }
    &::-moz-range-thumb {
        ${ThumbMixin}
    }
    &::-ms-track {
        ${TrackMixin}
        border-color: transparent;
        color: transparent;
    }
`;

export const V3RangeIptWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 20px;
`;

export const V3RangeIptProgress = styled.div<{ $progressColor?: string }>`
    height: 4px;
    background: ${({ theme, $progressColor }) => $progressColor ? $progressColor : theme.v3.colors.blue};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
`;